/*=============================================== CodeContainer ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
/*==================== Component ====================*/
var CodeContainer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (React.createElement(Container, __assign({}, props),
        React.createElement("pre", null,
            React.createElement("code", null, children))));
};
export default CodeContainer;
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    overflow-x: scroll;\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n\n    pre,\n    code {\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n        white-space: pre;\n        \n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n\n    code {\n        font-family: ", ";\n    }\n"], ["\n    width: 100%;\n    overflow-x: scroll;\n    background-color: ", ";\n    color: ", ";\n    padding: ", ";\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n\n    &::-webkit-scrollbar {\n        display: none;\n    }\n\n    pre,\n    code {\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n        white-space: pre;\n        \n        &::-webkit-scrollbar {\n            display: none;\n        }\n    }\n\n    code {\n        font-family: ", ";\n    }\n"])), Variables.Colors.Gray900, Variables.Colors.White, Variables.Spacers.M, Variables.FontFamilies.Code);
var templateObject_1;
